export const SITE_LISTING = "SITE_LISTING";
export const SITE_FILTERS = "SITE_FILTERS";
export const VIEW_DETAILS = "VIEW_DETAILS";
export const ASSIGNEE_LIST = "ASSIGNEE_LIST";
export const SITE_ENABLE_DISABLE = 'SITE_ENABLE_DISABLE';
export const SITE_PM_STATE_LIST = 'SITE_PM_STATE_LIST';
export const CONTRACT_DATA_FOR_RENEWAL = 'CONTRACT_DATA_FOR_RENEWAL';
export const RENEWAL_LIST = 'RENEWAL_LIST';
export const RENEWAL_BA_LISTING = 'RENEWAL_BA_LISTING';
export const HOTO_ASSIGNEE_LIST = "HOTO_ASSIGNEE_LIST";